import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import {UpdateIssuesBulk} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'
import {type JSONRequestInit, reactFetchJSON} from '@github-ui/verified-fetch'

export type UpdateIssueProjectBulkRequest = {
  ids: string[]
  addToProjectIds?: string[]
  removeFromProjectIds?: string[]
}

export type UpdateIssueProjectBulkResponse = GraphQLResponse<UpdateIssuesBulkMutation>

export async function apiUpdateIssueProjectBulk({
  ids,
  addToProjectIds,
  removeFromProjectIds,
}: UpdateIssueProjectBulkRequest): Promise<UpdateIssueProjectBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body = {
    ids,
    addToProjectIds,
    removeFromProjectIds,
    queryId: UpdateIssuesBulk,
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }

  const request = await reactFetchJSON(requestUrl, init)

  return (await request.json()) as UpdateIssueProjectBulkResponse
}
